import {Component} from '@angular/core';
import {MatDialog} from '@angular/material';

/**
 * @title Dialog elements
 */



@Component({
  //selector: 'dialog-elements-example-dialog',
  templateUrl: 'error-dialog-Added.html',
})
export class errorDialogDuplicate { 
  public title='Access denied ! Driver/Mate OR unauthorised email addresses are Restricted to portal login.';

}


